import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'toggle-specs',
  templateUrl: './toggle-specs.component.html',
  styleUrls: ['./toggle-specs.component.sass']
})
export class ToggleSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/toggle/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
